import React, {useState, useEffect} from "react";
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
//imported
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer'; 

import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
const Layout = (props) => {   
    const override = css`
    display: block;
    margin: 0 auto;
    `;
    let [color, setColor] = useState("#DD3E45");

    //sidebar
    const [isOpen, setIsOpen] = useState(false)
    const sidebarHideShow = () => {
        setIsOpen(!isOpen)
    };


    useEffect(() => {
        // sidebarHideShow()
    }, [isOpen])

    return(
            <div className={`container-scroller ${isOpen ? 'sidebar-icon-only' : ''}`}>
                <Helmet titleTemplate={`%s | ${process.env.REACT_APP_APPNAME}`} /> 
                <Header sidebarHideShow={sidebarHideShow}/> 
                <div className="container-fluid page-body-wrapper">
                    <Sidebar isOpen={isOpen}/> 
                    <div className="main-panel">
                        <div className="content-wrapper">
                            {React.cloneElement(props.children)}
                            {props.loader==true &&
                                <div className="main-loader">
                                    <div className="loader-class">
                                        <ClipLoader color={color} loading={props.loader} css={override} size={80} speedMultiplier={1} />
                                    </div>
                                </div>
                            }
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

    )
}
const mapStateToPros = (state) => {
    return{
        isAuthenticated: state.Auth.isAuthenticated,
        user: state.Auth,
        loader: state.persistStore.loader,
    }
};

export default connect(
  mapStateToPros,
)(Layout);




